import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import asyncAction from 'modules/core/lib/asyncAction'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'

import PaymentDateSelect from './PaymentDateSelect'

const PayrollHeader = () => (
  <PanesHeader
    title={i18n.t('settings.customizations.payroll.title')}
    illustration="cash"
    description={i18n.t('settings.customizations.payroll.description')}
  />
)

class SettingsForm extends Form {
  constructor(values: object) {
    super(values, {
      payroll_payment_date: 'string',
    })
  }
}

const PayrollSettingsForm: React.FC = () => {
  const form = useLazyRef(() => new SettingsForm(company().toJS())).current

  const company = (): Company => {
    return companies.current
  }

  const { has_payroll: hasPayroll } = useFeatures(['payroll'])

  const onSubmit = () => {
    return asyncAction(() => {
      if (!form) {
        return Promise.resolve()
      }

      return form.save(company())
    })
  }

  if (!hasPayroll) return null

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PayrollHeader />
      <FormComponent onSubmit={onSubmit}>
        <PaymentDateSelect paymentDate={form?.get('payroll_payment_date').value} />
        {form?.isDirty && (
          <FormRow footer>
            <Button submit>{i18n.t('common.submit')}</Button>
          </FormRow>
        )}
      </FormComponent>
    </PanesPadForm>
  )
}

export default observer(PayrollSettingsForm)
